var fn = function fn($rootScope, $compile) {
    return {
        getNodeFromTemplate: function getNodeFromTemplate(template, scopeValues) {
            var isolateScope = $rootScope.$new(true);
            isolateScope = angular.extend(isolateScope, scopeValues);
            var node = $compile(template)(isolateScope);
            isolateScope.$apply();
            return node;
        }
    };
};
fn.$inject = ['$rootScope', '$compile'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-util-angular/TemplateUtil.js
// module id = 930
// module chunks = 0